<script setup>
defineProps({
    titulo: {
        type: String,
    },
    descricao: {
        type: String,
        required: false,
        default: ''
    },
})
</script>

<template>
    <div class="field mt-4 mb-2 col-12">
        <div
            class="w-full col-12 m-0 text-500 px-4 flex flex-row align-items-center gap-2 py-3 border-1 surface-border border-round-lg">
            <i class="pi pi-info-circle mr-2"></i>
            <div class="text-900">
                <p class="text-sm m-0 font-normal mb-1">
                    {{ titulo }}

                    <slot name="titulo"></slot>
                </p>
                <p class="text-xs text-500 m-0">
                    {{ descricao }}

                    <slot name="descricao"></slot>
                </p>
            </div>
        </div>
    </div>
</template>
